module.exports = __webpack_public_path__ + "img/database.663422f4.svg";